(function () {
  function initAristaConversion() {
    var root = document.querySelector('[data-arista-conversion]');
    if (!root || root.dataset.aristaReady === 'true') return;
    root.dataset.aristaReady = 'true';

    var q = function (selector, scope) { return (scope || root).querySelector(selector); };
    var qa = function (selector, scope) { return Array.prototype.slice.call((scope || root).querySelectorAll(selector)); };
    var cartLayer = q('[data-arista-cart-drawer]');
    var quickviewLayer = q('[data-arista-quickview-modal]');
    var menuLayer = q('[data-arista-menu-drawer]');
    var state = {
      category: 'all',
      price: 'all',
      sort: 'recommended',
      currentProduct: null,
      currentVariant: null,
      cart: null,
      feeds: {},
      loadingMore: false,
      endReached: false
    };

    var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (rootPath.slice(-1) !== '/') rootPath += '/';

    function money(cents) {
      var value = Number(cents || 0) / 100;
      return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(value);
    }

    function escapeHtml(value) {
      return String(value == null ? '' : value).replace(/[&<>'"]/g, function (character) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
      });
    }

    function productFromCard(card) {
      try { return JSON.parse(card.getAttribute('data-product-json') || '{}'); } catch (error) { return {}; }
    }

    function imageFor(product) {
      var image = product.featured_image || (product.images && product.images[0]);
      if (!image) return '';
      return typeof image === 'string' ? image : image.src || image.url || '';
    }

    function firstAvailableVariant(product) {
      var variants = product.variants || [];
      return variants.find(function (variant) { return variant.available !== false; }) || variants[0] || null;
    }

    function priceInCents(variant) {
      return Math.round(parseFloat((variant && variant.price) || 0) * 100);
    }

    function compareInCents(variant) {
      return Math.round(parseFloat((variant && variant.compare_at_price) || 0) * 100);
    }

    function setBodyLocked(locked) {
      document.documentElement.classList.toggle('arista-modal-open', locked);
    }

    function flyToCart(source) {
      var cartTrigger = q('[data-arista-cart-open]');
      if (!source || !cartTrigger || !document.body) return;
      var image = source.tagName === 'IMG' ? source : source.querySelector('img');
      if (!image || !image.src) return;

      var sourceRect = source.getBoundingClientRect();
      var targetRect = cartTrigger.getBoundingClientRect();
      var size = Math.max(58, Math.min(112, Math.min(sourceRect.width, sourceRect.height)));
      var startLeft = sourceRect.left + ((sourceRect.width - size) / 2);
      var startTop = sourceRect.top + ((sourceRect.height - size) / 2);
      var startCenterX = startLeft + (size / 2);
      var startCenterY = startTop + (size / 2);
      var targetCenterX = targetRect.left + (targetRect.width / 2);
      var targetCenterY = targetRect.top + (targetRect.height / 2);
      var clone = document.createElement('img');

      clone.className = 'arista-fly-to-cart';
      clone.src = image.currentSrc || image.src;
      clone.alt = '';
      clone.setAttribute('aria-hidden', 'true');
      clone.style.width = size + 'px';
      clone.style.height = size + 'px';
      clone.style.left = startLeft + 'px';
      clone.style.top = startTop + 'px';
      clone.style.setProperty('--fly-x', (targetCenterX - startCenterX) + 'px');
      clone.style.setProperty('--fly-y', (targetCenterY - startCenterY) + 'px');
      document.body.appendChild(clone);

      window.requestAnimationFrame(function () {
        clone.classList.add('is-flying');
        cartTrigger.classList.add('is-bumping');
      });

      window.setTimeout(function () {
        clone.remove();
        cartTrigger.classList.remove('is-bumping');
      }, 680);
    }

    function openLayer(layer, opener) {
      [cartLayer, quickviewLayer, menuLayer].forEach(function (candidate) {
        if (candidate && candidate !== layer) closeLayer(candidate);
      });
      if (!layer) return;
      layer.classList.add('is-open');
      layer.setAttribute('aria-hidden', 'false');
      setBodyLocked(true);
      if (opener) layer.dataset.opener = opener;
    }

    function closeLayer(layer) {
      if (!layer) return;
      layer.classList.remove('is-open');
      layer.setAttribute('aria-hidden', 'true');
      if (![cartLayer, quickviewLayer, menuLayer].some(function (candidate) { return candidate && candidate.classList.contains('is-open'); })) setBodyLocked(false);
    }

    function closeAllLayers() {
      closeLayer(cartLayer);
      closeLayer(quickviewLayer);
      closeLayer(menuLayer);
    }

    function priceRange() {
      if (state.price === 'all') return [0, Infinity];
      var parts = state.price.split('-');
      return [Number(parts[0]) * 100, Number(parts[1]) * 100];
    }

    function categoryMatches(widgetKey) {
      return state.category === 'all' || state.category === widgetKey;
    }

    function updateBogoHeading() {
      var bogoWidget = q('[data-arista-widget][data-widget-key="bogo"]');
      if (!bogoWidget) return;
      var eyebrow = q('.arista-eyebrow', bogoWidget);
      var title = q('.arista-widget-heading h2', bogoWidget);
      var bogoSelected = state.category === 'bogo';
      if (eyebrow) eyebrow.textContent = bogoSelected ? 'The offer edit' : 'A little something for everyone';
      if (title) title.textContent = bogoSelected ? 'Buy 1 Get 1' : 'Best picks';
    }

    function applyFilters() {
      updateBogoHeading();
      var range = priceRange();
      var total = 0;
      qa('[data-arista-widget]').forEach(function (widget) {
        var categoryMatch = categoryMatches(widget.dataset.widgetKey);
        var visibleInWidget = 0;
        qa('[data-arista-product]', widget).forEach(function (card) {
          var price = Number(card.dataset.price || 0);
          var visible = categoryMatch && price >= range[0] && price <= range[1];
          card.hidden = !visible;
          if (visible) visibleInWidget += 1;
        });
        widget.hidden = !categoryMatch || visibleInWidget === 0;
        total += visibleInWidget;
      });
      var count = q('[data-arista-results-count]');
      if (count) count.textContent = total;
    }

    function setSelected(selector, attribute, value) {
      qa(selector).forEach(function (button) {
        var active = button.getAttribute(attribute) === value;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function revealCategory(categoryButton) {
      var tabsScroll = q('.arista-tabs-scroll');
      var category = categoryButton && categoryButton.dataset.aristaCategory;
      if (!tabsScroll || window.innerWidth > 767 || ['bogo', 'bestsellers', 'nazariya'].indexOf(category) === -1) return;
      var scrollRect = tabsScroll.getBoundingClientRect();
      var buttonRect = categoryButton.getBoundingClientRect();
      var targetLeft = tabsScroll.scrollLeft + buttonRect.left - scrollRect.left - 18;
      var maxScroll = tabsScroll.scrollWidth - tabsScroll.clientWidth;
      tabsScroll.scrollTo({ left: Math.max(0, Math.min(maxScroll, targetLeft)), behavior: 'smooth' });
    }

    function sortProducts() {
      qa('[data-arista-product-grid]').forEach(function (grid) {
        qa('[data-arista-product]', grid).sort(function (a, b) {
          if (state.sort === 'price-low') return Number(a.dataset.price) - Number(b.dataset.price);
          if (state.sort === 'price-high') return Number(b.dataset.price) - Number(a.dataset.price);
          return 0;
        }).forEach(function (card) { grid.appendChild(card); });
      });
    }

    function openQuickview(product) {
      var variant = firstAvailableVariant(product);
      if (!variant) return;
      state.currentProduct = product;
      state.currentVariant = variant;
      var image = q('[data-arista-quickview-image]');
      var title = q('[data-arista-quickview-title]');
      var price = q('[data-arista-quickview-price]');
      var compare = q('[data-arista-quickview-compare]');
      var saving = q('[data-arista-quickview-saving]');
      var rating = q('[data-arista-quickview-rating]');
      var description = q('[data-arista-quickview-description]');
      var specs = q('[data-arista-quickview-specs]');
      var select = q('[data-arista-variant-select]');
      var variantWrap = q('[data-arista-variant-wrap]');
      var buyButton = q('[data-arista-quickview-buy]');
      var imageUrl = imageFor(product);

      image.src = imageUrl;
      image.alt = product.title || '';
      title.textContent = product.title || '';
      price.textContent = money(priceInCents(variant));
      var compareCents = compareInCents(variant);
      compare.textContent = compareCents > priceInCents(variant) ? money(compareCents) : '';
      saving.textContent = compareCents > priceInCents(variant) ? 'Save ' + money(compareCents - priceInCents(variant)) : '';
      rating.textContent = product.vendor ? product.vendor + ' · Arista original' : 'Arista original';
      description.textContent = String(product.description || product.body_html || 'A thoughtfully made Arista piece for everyday keeps.').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 260);
      specs.innerHTML = '';
      [
        ['Material', product.type || 'Baby jewellery'],
        ['Availability', variant.available === false ? 'Currently unavailable' : 'In stock'],
        ['Delivery', 'Express delivery available'],
        ['Exchange', 'Lifetime exchange policy']
      ].forEach(function (row) {
        var line = document.createElement('p');
        line.innerHTML = '<span>' + escapeHtml(row[0]) + '</span><strong>' + escapeHtml(row[1]) + '</strong>';
        specs.appendChild(line);
      });

      select.innerHTML = '';
      var variants = product.variants || [];
      variants.forEach(function (option) {
        var item = document.createElement('option');
        item.value = option.id;
        item.textContent = (option.title && option.title !== 'Default Title' ? option.title + ' · ' : '') + money(priceInCents(option));
        item.disabled = option.available === false;
        item.selected = String(option.id) === String(variant.id);
        select.appendChild(item);
      });
      variantWrap.hidden = variants.length <= 1;
      buyButton.disabled = variant.available === false;
      buyButton.textContent = variant.available === false ? 'Sold out' : 'Buy now  →';
      openLayer(quickviewLayer, 'quickview');
    }

    async function addToCart(variantId, quantity, button, source) {
      if (!variantId) return;
      if (button) { button.disabled = true; button.dataset.originalLabel = button.textContent; button.textContent = 'Adding…'; }
      flyToCart(source);
      try {
        var response = await fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity || 1) }] })
        });
        if (!response.ok) throw new Error('Unable to add item');
        await refreshCart();
      } catch (error) {
        window.console && console.error('[Arista cart]', error);
        window.alert('This piece could not be added right now. Please try again.');
      } finally {
        if (button) { button.disabled = false; button.textContent = button.dataset.originalLabel || 'Buy now'; }
      }
    }

    async function refreshCart(openAfter) {
      try {
        var response = await fetch(rootPath + 'cart.js', { headers: { 'Accept': 'application/json' } });
        if (!response.ok) throw new Error('Unable to load cart');
        state.cart = await response.json();
        renderCart();
        if (openAfter !== false) openLayer(cartLayer, 'cart');
      } catch (error) {
        window.console && console.error('[Arista cart]', error);
      }
    }

    function renderCart() {
      if (!state.cart) return;
      var countNodes = document.querySelectorAll('[data-arista-cart-count]');
      Array.prototype.forEach.call(countNodes, function (node) { node.textContent = state.cart.item_count || 0; });
      var items = q('[data-arista-cart-items]');
      var empty = q('[data-arista-cart-empty]');
      var total = q('[data-arista-cart-total]');
      var savings = q('[data-arista-cart-savings]');
      var progress = q('[data-arista-cart-progress]');
      if (!items || !empty || !total || !savings || !progress) return;
      empty.hidden = state.cart.items.length > 0;
      items.innerHTML = state.cart.items.map(function (item, index) {
        var image = item.image || '';
        return '<article class="arista-cart-item">' +
          '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(item.product_title || item.title) + '" width="84" height="84">' +
          '<div><h3>' + escapeHtml(item.product_title || item.title) + '</h3>' +
          '<div class="arista-cart-item-price">' + money(item.final_line_price) + '</div>' +
          '<div class="arista-cart-item-actions"><div class="arista-quantity-control"><button type="button" data-arista-cart-change data-line="' + (index + 1) + '" data-quantity="' + Math.max(0, item.quantity - 1) + '" aria-label="Decrease quantity">−</button><span>' + item.quantity + '</span><button type="button" data-arista-cart-change data-line="' + (index + 1) + '" data-quantity="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button></div><button class="arista-cart-remove" type="button" data-arista-cart-change data-line="' + (index + 1) + '" data-quantity="0">Remove</button></div></div></article>';
      }).join('');
      total.textContent = money(state.cart.total_price);
      savings.textContent = state.cart.total_discount > 0 ? 'You saved ' + money(state.cart.total_discount) + ' with current Shopify discounts.' : '';
      if (state.cart.item_count >= 2) {
        progress.innerHTML = '<strong>Offer eligibility ready</strong>Your eligible Buy 1 Get 1 discount will be reflected by Shopify at checkout.';
      } else {
        progress.innerHTML = '<strong>Add one more piece to unlock the offer.</strong>Mix and match across the collection.';
      }
    }

    async function changeCart(line, quantity) {
      try {
        var response = await fetch(rootPath + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
        });
        if (!response.ok) throw new Error('Unable to update cart');
        await refreshCart(false);
      } catch (error) {
        window.console && console.error('[Arista cart]', error);
      }
    }

    function dynamicCard(product, widgetKey) {
      var variant = firstAvailableVariant(product);
      if (!variant) return '';
      var image = imageFor(product);
      var compare = compareInCents(variant);
      var price = priceInCents(variant);
      var json = escapeHtml(JSON.stringify(product));
      return '<article class="arista-product-card" data-arista-product data-section-key="' + escapeHtml(widgetKey) + '" data-price="' + price + '" data-handle="' + escapeHtml(product.handle) + '" data-variant-id="' + escapeHtml(variant.id) + '" data-available="' + (variant.available !== false) + '" data-product-json="' + json + '">' +
        '<div class="arista-card-media"><a href="#quick-view" class="arista-card-image-link" data-arista-quickview-trigger aria-label="View ' + escapeHtml(product.title) + '"><img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" width="720" height="720" loading="lazy"></a><div class="arista-card-badges">' + (widgetKey === 'bogo' ? '<span class="arista-offer-chip">BUY 1 GET 1 FREE</span>' : '') + '</div><button class="arista-quick-view-chip" type="button" data-arista-quickview-trigger>Quick view</button></div>' +
        '<div class="arista-card-body"><div class="arista-card-meta"><h3>' + escapeHtml(product.title) + '</h3></div><div class="arista-card-price-row"><span class="arista-price">' + money(price) + '</span>' + (compare > price ? '<del>' + money(compare) + '</del><span class="arista-saving">Save ' + money(compare - price) + '</span>' : '') + '</div><button class="arista-buy-button" type="button" data-arista-buy-now' + (variant.available === false ? ' disabled' : '') + '>' + (variant.available === false ? 'Sold out' : 'Buy now') + '</button></div></article>';
    }

    async function loadMoreProducts() {
      if (state.loadingMore || state.endReached) return;
      state.loadingMore = true;
      var appended = 0;
      try {
        await Promise.all(qa('[data-arista-widget]').map(async function (widget) {
          var handle = widget.dataset.collectionHandle;
          if (!handle) return;
          if (!state.feeds[handle]) {
            var response = await fetch(rootPath + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=250');
            if (!response.ok) return;
            state.feeds[handle] = await response.json();
            state.feeds[handle].next = 0;
          }
          var feed = state.feeds[handle];
          var existing = new Set(qa('[data-arista-product]', widget).map(function (card) { return card.dataset.handle; }));
          var candidates = (feed.products || []).filter(function (product) { return !existing.has(product.handle); }).slice(feed.next, feed.next + 6);
          feed.next += candidates.length;
          if (!candidates.length) return;
          var grid = q('[data-arista-product-grid]', widget);
          candidates.forEach(function (product) {
            var wrapper = document.createElement('div');
            wrapper.innerHTML = dynamicCard(product, widget.dataset.widgetKey);
            if (wrapper.firstElementChild) { grid.appendChild(wrapper.firstElementChild); appended += 1; }
          });
        }));
      } catch (error) {
        window.console && console.warn('[Arista infinite scroll]', error);
      }
      state.loadingMore = false;
      if (!appended) {
        state.endReached = true;
        var label = q('[data-arista-load-more-label]');
        if (label) label.textContent = 'You are all caught up';
      } else {
        applyFilters();
        sortProducts();
      }
    }

    root.addEventListener('click', function (event) {
      var categoryButton = event.target.closest('[data-arista-category]');
      if (categoryButton) {
        state.category = categoryButton.dataset.aristaCategory;
        setSelected('[data-arista-category]', 'data-arista-category', state.category);
        revealCategory(categoryButton);
        applyFilters();
        return;
      }
      var priceButton = event.target.closest('[data-arista-price]');
      if (priceButton) {
        state.price = priceButton.dataset.aristaPrice;
        setSelected('[data-arista-price]', 'data-arista-price', state.price);
        applyFilters();
        return;
      }
      var quickTrigger = event.target.closest('[data-arista-quickview-trigger]');
      if (quickTrigger) {
        event.preventDefault();
        var card = quickTrigger.closest('[data-arista-product]');
        if (card) openQuickview(productFromCard(card));
        return;
      }
      var buyButton = event.target.closest('[data-arista-buy-now]');
      if (buyButton) {
        var buyCard = buyButton.closest('[data-arista-product]');
        if (buyCard) addToCart(buyCard.dataset.variantId, 1, buyButton, buyCard.querySelector('.arista-card-media'));
        return;
      }
      var changeButton = event.target.closest('[data-arista-cart-change]');
      if (changeButton) {
        changeCart(changeButton.dataset.line, changeButton.dataset.quantity);
        return;
      }
      var menuLink = event.target.closest('[data-arista-menu-link]');
      if (menuLink) {
        closeLayer(menuLayer);
        var target = document.querySelector(menuLink.getAttribute('href'));
        if (target) { event.preventDefault(); setTimeout(function () { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 80); }
        return;
      }
      var widgetLink = event.target.closest('[data-arista-widget-link]');
      if (widgetLink) {
        event.preventDefault();
        var widget = document.getElementById('arista-widget-' + widgetLink.dataset.aristaWidgetLink);
        if (widget) widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-arista-menu-open]')) openLayer(menuLayer, 'menu');
      if (event.target.closest('[data-arista-cart-open]')) { refreshCart(true); }
      if (event.target.closest('[data-arista-menu-close]')) closeLayer(menuLayer);
      if (event.target.closest('[data-arista-cart-close]')) closeLayer(cartLayer);
      if (event.target.closest('[data-arista-quickview-close]')) closeLayer(quickviewLayer);
      if (event.target.closest('[data-arista-scroll-link]')) { setTimeout(function () { var target = document.querySelector('#collections'); if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 30); }
      if (event.target.closest('[data-arista-sort-toggle]')) {
        state.sort = state.sort === 'recommended' ? 'price-low' : state.sort === 'price-low' ? 'price-high' : 'recommended';
        var label = state.sort === 'recommended' ? 'Recommended' : state.sort === 'price-low' ? 'Price low to high' : 'Price high to low';
        var sortButton = q('[data-arista-sort-toggle]');
        if (sortButton) sortButton.innerHTML = escapeHtml(label) + ' <span aria-hidden="true">⌄</span>';
        sortProducts();
      }
    });

    var variantSelect = q('[data-arista-variant-select]');
    if (variantSelect) variantSelect.addEventListener('change', function () {
      var selected = (state.currentProduct.variants || []).find(function (variant) { return String(variant.id) === String(variantSelect.value); });
      if (!selected) return;
      state.currentVariant = selected;
      q('[data-arista-quickview-price]').textContent = money(priceInCents(selected));
      q('[data-arista-quickview-compare]').textContent = compareInCents(selected) > priceInCents(selected) ? money(compareInCents(selected)) : '';
      q('[data-arista-quickview-saving]').textContent = compareInCents(selected) > priceInCents(selected) ? 'Save ' + money(compareInCents(selected) - priceInCents(selected)) : '';
      var button = q('[data-arista-quickview-buy]');
      button.disabled = selected.available === false;
      button.textContent = selected.available === false ? 'Sold out' : 'Buy now  →';
    });

    var quickviewBuy = q('[data-arista-quickview-buy]');
    if (quickviewBuy) quickviewBuy.addEventListener('click', function () {
      if (state.currentVariant) addToCart(state.currentVariant.id, 1, quickviewBuy, q('[data-arista-quickview-image]'));
    });

    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeAllLayers(); });

    var sentinel = q('[data-arista-load-more]');
    if ('IntersectionObserver' in window && sentinel) {
      var observer = new IntersectionObserver(function (entries) { if (entries.some(function (entry) { return entry.isIntersecting; })) loadMoreProducts(); }, { rootMargin: '500px 0px' });
      observer.observe(sentinel);
    }

    applyFilters();
    refreshCart(false);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAristaConversion);
  else initAristaConversion();
})();
